import {
  IIkCardSelectableIconItem
} from '@infomaniak/angular-common/src/components/ik-card-selectable-icon-item/ik-card-selectable-icon-item.interfaces';
import { translate } from '@ngneat/transloco';

export function getClientIkCardSelectableIconItemForOrdersAndRenewals(): IIkCardSelectableIconItem {
  return {
    // icon: 'icon-accounting-document',
    icon: 'icon-receipt',
    title: translate('Commandes et renouvellements'),
    description: translate('Le partenaire pourra commander et renouveller des produits pour votre organisation.'),
  };
}
